import type { MatchAllResult} from 'portlet/common/utils/regex';
import { matchAll } from 'portlet/common/utils/regex';
import type { FilterData, SettingValueMap } from 'portlet/models';
import type { DatabricksQueryTable } from 'portlet/models/query/systems/databricks';

import { FilterQueryReplacer } from './FilterQueryReplacer';
import { FilterValueQueryReplacer } from './FilterValueQueryReplacer';
import { ConditionFieldReplacer } from './ConditionFieldReplacer';
import { ConditionLimitReplacer } from './ConditionLimitReplacer';
import { ConditionOrderReplacer } from './ConditionOrderReplacer';
import { ConditionAllReplacer } from './ConditionAllReplacer';
import { DrillReplacer } from './DrillReplacer';

export interface QueryReplacer {
    readonly regex: RegExp;
    replace: (
        statement: string,
        tables: DatabricksQueryTable[],
        filtersValue: FilterData[],
        regexMatches: MatchAllResult[],
        settings: Partial<SettingValueMap>,
    ) => string;
}

// Add new replacers here
const queryReplacersList: QueryReplacer[] = [
    FilterQueryReplacer,
    FilterValueQueryReplacer,
    ConditionFieldReplacer,
    ConditionLimitReplacer,
    ConditionOrderReplacer,
    ConditionAllReplacer,
    DrillReplacer,
];

export const queryReplacer = (
    statement: string,
    tables: DatabricksQueryTable[],
    filtersValue: FilterData[],
    settings: Partial<SettingValueMap>,
): string =>
    queryReplacersList.reduce((pre, cur) => {
        const regexMatches = matchAll(cur.regex, pre);

        return cur.replace(pre, tables, filtersValue, regexMatches, settings);
    }, statement);
